// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Tag {
}

export default Tag
